var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "el-dialog": "",
            width: "50%",
            title: _vm.bestsignAgreementName,
            visible: _vm.bestsignContentVisible,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.bestsignContentVisible = $event
            }
          }
        },
        [_c("bestsign")],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "auth-file-dialog",
          attrs: {
            title: "重要事项提醒",
            visible: _vm.authFileDialogVisible,
            width: "420px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.authFileDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "auth-file-content" }, [
            _c("p", [_vm._v("1、请打印《企业授权书》并盖章，提供PDF或图片")]),
            _c("p", [
              _vm._v("2、请保证授权书中"),
              _c("span", { staticClass: "red" }, [
                _vm._v("被授权人与当前操作人保持一致")
              ]),
              _vm._v("以免认证失败")
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "auth-file-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: { click: _vm.onAuthFileReady }
                },
                [_vm._v("已准备好")]
              ),
              _c("div", { staticClass: "mar10-t" }, [
                _c(
                  "a",
                  {
                    staticClass: "red",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        _vm.authFileDialogVisible = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                )
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "contract",
          attrs: {
            top: "5vh",
            width: "80%",
            title:
              _vm.buildContractVisible || _vm.isShowOrderButton
                ? "签署合同"
                : "查看合同",
            visible: _vm.contractVisible,
            "append-to-body": "",
            fullscreen: _vm.isFullscreen,
            "show-close": _vm.isShowClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.contractVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-column",
              style: { height: (_vm.isFullscreen ? 91.5 : 80) + "vh" }
            },
            [
              _vm.contractInfo.length > 1
                ? _c(
                    "el-tabs",
                    {
                      staticClass: "flex-shrink",
                      on: { "tab-click": _vm.tabClick },
                      model: {
                        value: _vm.contractTemplateName,
                        callback: function($$v) {
                          _vm.contractTemplateName = $$v
                        },
                        expression: "contractTemplateName"
                      }
                    },
                    _vm._l(_vm.contractInfo, function(item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: {
                          label: item.templateName,
                          name: item.contractUrl
                        }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "flex-auto",
                  class: { "mar10-t": _vm.contractInfo.length <= 1 }
                },
                [
                  _vm.contractInfo.length && _vm.iframeVisible
                    ? _c("iframe", {
                        staticStyle: { overflow: "auto" },
                        attrs: {
                          src:
                            _vm.contractInfo[_vm.contractInfoIndex].contractUrl,
                          frameborder: "0",
                          width: "100%",
                          height: "100%"
                        }
                      })
                    : _vm._e()
                ]
              ),
              (_vm.buildContractVisible || _vm.isShowOrderButton) &&
              _vm.bestsignAgreementUrl
                ? _c(
                    "div",
                    { staticClass: "text-center flex-shrink pad20_b pad15-tb" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.onSignTreatyChange },
                          model: {
                            value: _vm.isSignTreaty,
                            callback: function($$v) {
                              _vm.isSignTreaty = $$v
                            },
                            expression: "isSignTreaty"
                          }
                        },
                        [
                          _vm._v("我已阅读并同意"),
                          _c(
                            "a",
                            {
                              staticClass: "red",
                              attrs: { href: _vm.bestsignAgreementUrl },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "《" + _vm._s(_vm.bestsignAgreementName) + "》"
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _c("div", { staticClass: "pad10" }),
              _vm.buildContractVisible || _vm.isShowOrderButton
                ? _c(
                    "div",
                    { staticClass: "d_btn d_btn1 flex-shrink text-center" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "danger" },
                          on: { click: _vm.buildContract }
                        },
                        [_vm._v("我已阅读并同意签署")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "danger" },
                          on: { click: _vm.downloadPDF }
                        },
                        [_vm._v("下载")]
                      ),
                      _vm.isShowOrderButton
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "medium", type: "danger" },
                              on: { click: _vm.toOrderDetail }
                            },
                            [_vm._v("前往订单详情")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "d_btn d_btn1 flex-shrink text-center" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "danger" },
                          on: { click: _vm.downloadPDFSigned }
                        },
                        [_vm._v("下载")]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }